import { Pipe, PipeTransform } from '@angular/core';

/**
  * ReversePipe
  *
  * Pipe to reverse a give array.
  */
@Pipe({ name: 'reverse', pure: false })
export class ReversePipe implements PipeTransform {
  /**
  * Accepts an array and returns the reversed of it
  *
  * @param {any[]} value Any given array.
  * @return {any[]} Returns reversed value of given array.
  */
  transform(value: any[]): any[] {
    return Array.from(value).reverse();
    ;
  }
}
